import React, { useEffect, useState } from 'react';
import { Nav, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import TechnicalNavItem from './submit_application/TechnicalNavItem';
import bsfzNavigationsService from '@rd-web-markets/de/dist/services/bsfz_navigations.service';
import { useTranslation } from 'react-i18next';
const ClaimProjectReportDetailsNavigation = _ref => {
  let {
    firstFastCheck,
    claimGroup,
    report,
    page,
    id
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [tabs, setTabs] = useState(null);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      const tabs = await bsfzNavigationsService.get(report.id);
      setTabs(tabs);
    };
    fetchData();
  }, [id]);
  if (!tabs) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'general',
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/project_reports/${report.id}`
  }, t('bsfz_start_project'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'first_fast_check',
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/project_reports/${report.id}/first_fast_check`
  }, t('first_fast_check'))), firstFastCheck.should_advance !== false && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'creating_application',
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/project_reports/${report.id}/creating_application/overview`
  }, t('creating_application'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'submit_application',
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/project_reports/${report.id}/submit_application/submission_overview`
  }, t('submit_application'))), tabs.map(tab => {
    return /*#__PURE__*/React.createElement(TechnicalNavItem, {
      key: tab.id,
      report: report,
      page: page,
      claimGroup: claimGroup,
      tab: tab,
      user: user,
      id: id
    });
  })), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'bsfz_project_overview',
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/project_reports/${report.id}/bsfz_project_overview`
  }, t('bsfz_project_overview')))));
};
export default ClaimProjectReportDetailsNavigation;